import { z } from "zod";
import { LIMITS } from "./limits";

/** Query string of a list request. The cursor is opaque to callers. */
export const pageQuerySchema = z.object({
  limit: z.coerce
    .number()
    .int()
    .min(LIMITS.pageSize.min)
    .max(LIMITS.pageSize.max)
    .default(LIMITS.pageSize.fallback),
  cursor: z.string().min(1).max(200).optional(),
});

/** One page of a list: the items, and the cursor for the next page if there is one. */
export const pageOf = <Item extends z.ZodType>(item: Item) =>
  z.object({ items: z.array(item), nextCursor: z.string().nullable() });

export type PageQuery = z.infer<typeof pageQuerySchema>;
export type Page<Item> = { items: Item[]; nextCursor: string | null };
